<donut-widgets-generic v-if="shouldDisplay" title-icon="star" title="Highlighted stories" :items="items" widget-name="article"></donut-widgets-generic>